import React, { useState } from 'react';
import Modal from 'react-modal';
import './styles.scss';

const EditRoleModal = ({ closeModal, roleName, roleId, handleUpdateUnitRole }) => {
  const [formData, setFormData] = useState({
    name: roleName,
  });

  const handleClose = () => {
    closeModal();
  };

  const handleConfirm = () => {
    handleUpdateUnitRole(roleId, formData);
    handleClose();
  };

  return (
    <Modal className="modal-alert add-role-modal" isOpen onRequestClose={handleClose} contentLabel="Delete note modal" ariaHideApp={false}>
      <h2 className="modal-header">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="5" y="5" width="38" height="38" rx="19" fill="#F4EBFF" />
          <rect x="5" y="5" width="38" height="38" rx="19" stroke="#F9F5FF" strokeWidth="10" />
          <g clipPath="url(#clip0_13568_101251)">
            <path
              d="M23.3333 18.6642H18.6666C18.313 18.6642 17.9738 18.8047 17.7238 19.0547C17.4737 19.3048 17.3333 19.6439 17.3333 19.9975V29.3309C17.3333 29.6845 17.4737 30.0236 17.7238 30.2737C17.9738 30.5237 18.313 30.6642 18.6666 30.6642H27.9999C28.3535 30.6642 28.6927 30.5237 28.9427 30.2737C29.1928 30.0236 29.3333 29.6845 29.3333 29.3309V24.6642M28.3333 17.6642C28.5985 17.399 28.9582 17.25 29.3333 17.25C29.7083 17.25 30.068 17.399 30.3333 17.6642C30.5985 17.9294 30.7475 18.2891 30.7475 18.6642C30.7475 19.0393 30.5985 19.399 30.3333 19.6642L23.9999 25.9975L21.3333 26.6642L21.9999 23.9975L28.3333 17.6642Z"
              stroke="#7F56D9"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_13568_101251">
              <rect width="16" height="16" fill="white" transform="translate(16 16)" />
            </clipPath>
          </defs>
        </svg>

        <button className="btn btn-icon" onClick={handleClose}>
          <i className="icon-icon-x"></i>
        </button>
      </h2>

      <div>
        <h3>Edit line</h3>
        <div className="form-item">
          <input
            name="name"
            value={formData.name}
            className="form-control"
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn btn-outline" onClick={handleClose}>
          Cancel
        </button>
        <button
          className="btn"
          onClick={(e) => {
            e.stopPropagation();
            handleConfirm();
          }}
          disabled={!formData.name}
        >
          Confirm
        </button>
      </div>
    </Modal>
  );
};

export default EditRoleModal;
